module.exports = __webpack_public_path__ + "static/index/img/baikal-602.5e4de964.jpg";